
// TODO - Type 'any' needs to be fixed.

export const resetRenotifyWorkersReducer = (state:any, action:any) => {
    state.renotifyWorkers.status = "idle";
    state.renotifyWorkers.errorMessage = "";
}